import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-attributed-list-entry-attribute",
    styleUrls: ["./attributed-list-entry-attribute.component.scss"],
    templateUrl: "./attributed-list-entry-attribute.component.html",
    standalone: false
})
export class FUIAttributedListEntryAttributeComponent {
    @Input() public value: any;
}
